import { ImageProps } from '@/components/atoms/image/image';

const variables: {
  imageAspectRatio: ImageProps['aspectRatio'];
} = {
  imageAspectRatio: 'threeByFour',
};

export default variables;
